module.exports = __webpack_public_path__ + "static/media/Electrode_gaussian2.37763661.png";